import React from 'react';
import {Link} from 'react-router-dom';
import '../../assets/css/BreadcrumbStyle.css';

const Breadcrumb = () => {
   return (
    <> 
    
     <div className="bg-gray-50 py-3 top-box-margin" style={{ backgroundColor: "rgb(238 238 238)"}}>
        <div className="container mx-auto px-2">
          <nav className="text-sm" aria-label="breadcrumb">
            <ol className="flex space-x-2 text-gray-500" style={{ paddingLeft: "0", marginBottom: "0px" }}>
               <li className="breadcrumb-item">
                   <Link to="/" className="text-gray-700 text-decoration-none hover:underline" style={{ color:"#000"}}>Home</Link>
                   <span className="mx-1" style={{ color:"#000"}}>/</span>
               </li>
              <li className="text-gray-500" aria-current="page" style={{ marginLeft: "0", color:"#000" }}>Carpet</li>
            </ol>
          </nav>
        </div>
      </div>
    
    </>
  );
};
export default Breadcrumb;